/**
 * Dp 25-08 — Prefer exact product title / SKU matches in predictive search.
 * If the query equals a product title (e.g. "Willowbrook Screen & Storm Door"),
 * only that product is shown. Partial queries (e.g. "Willowbrook") still show all matches.
 *
 * Upload as theme asset: assets/dp-search-exact-match.js
 * Include once in layout/theme.liquid before </body>:
 *   <script src="{{ 'dp-search-exact-match.js' | asset_url }}" defer></script>
 */
(function () {
  if (window.__dpSearchExactMatch) return;
  window.__dpSearchExactMatch = true;

  function normTitle(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normSku(s) {
    return String(s == null ? '' : s).toLowerCase().trim();
  }

  function queryFromUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      return u.searchParams.get('q') || '';
    } catch (e) {
      var m = String(url).match(/[?&]q=([^&]*)/);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : '';
    }
  }

  function productMatchesExact(product, qNorm, qSku) {
    if (!product) return false;
    if (qNorm && normTitle(product.title) === qNorm) return true;
    if (qSku) {
      if (normSku(product.sku) === qSku) return true;
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v) continue;
        if (normSku(v.sku) === qSku) return true;
      }
    }
    return false;
  }

  var GENERIC_COLLECTIONS = [
    'best-sellers',
    'best-seller',
    'all-craftsman-doors',
    'screen-storm-doors',
    'screen-and-storm-doors',
    'porch-panels',
    'porch-panel',
    'exterior-doors',
    'interior-doors',
    'colonial',
    'cape-cod',
    'coastal',
    'farmhouse',
    'cottage',
    'rustic',
    'tudor',
    'victorian',
    'all-victorian',
    'all'
  ];

  function resolveCollectionForUrl(url, title, handle) {
    var u = String(url || '').toLowerCase();
    var t = String(title || '').toLowerCase();
    var h = String(handle || '').toLowerCase();

    // 1. Screen & Storm Doors
    if (u.indexOf('view=screen-storm') !== -1 || t.indexOf('screen') !== -1 || h.indexOf('screen') !== -1 || h.indexOf('-st') !== -1) {
      if (t.indexOf('round top') !== -1 || h.indexOf('round-top') !== -1 || h.indexOf('arch') !== -1) {
        return 'arch-round-top-screen-storm-doors';
      }
      if (t.indexOf('double') !== -1 || h.indexOf('double') !== -1 || h.indexOf('dbl-') !== -1) {
        return 'double-screen-storm-doors';
      }
      if (t.indexOf('louver') !== -1 || h.indexOf('louver') !== -1) {
        return 'louver-screen-storm-doors';
      }
      if (t.indexOf('victorian') !== -1 || h.indexOf('victorian') !== -1 || h.indexOf('v159') !== -1 || h.indexOf('v160') !== -1) {
        return 'victorian-screen-storm-doors';
      }
      if (t.indexOf('rustic') !== -1 || h.indexOf('rustic') !== -1 || h.indexOf('r107') !== -1) {
        return 'rustic-screen-storm-doors';
      }
      if (t.indexOf('craftsman') !== -1 || h.indexOf('craftsman') !== -1) {
        return 'craftsman-screen-storm-doors';
      }
      return 'traditional-screen-storm-doors';
    }

    // 2. Porch Panels
    if (u.indexOf('view=porch-panel') !== -1 || t.indexOf('porch') !== -1 || h.indexOf('porch') !== -1) {
      if (t.indexOf('traditional') !== -1 || h.indexOf('traditional') !== -1) {
        return 'traditional-porch-enclosure-panels';
      }
      if (t.indexOf('victorian') !== -1 || h.indexOf('victorian') !== -1) {
        return 'victorian-porch-enclosure-panels';
      }
      if (t.indexOf('craftsman') !== -1 || h.indexOf('craftsman') !== -1) {
        return 'craftsman-porch-enclosure-panels';
      }
      if (t.indexOf('louver') !== -1 || h.indexOf('louver') !== -1) {
        return 'louver-porch-enclosure-panels';
      }
      return 'traditional-porch-enclosure-panels';
    }

    // 3. Garden Gates & Pet Gates
    if (u.indexOf('view=garden-gates') !== -1 || t.indexOf('garden gate') !== -1 || h.indexOf('garden-gate') !== -1) {
      return 'garden-gates';
    }
    if (u.indexOf('view=pet-gates') !== -1 || t.indexOf('pet gate') !== -1 || h.indexOf('pet-gate') !== -1) {
      return 'pet-gates';
    }

    // 4. Entrance Units
    if (u.indexOf('view=entrance-units') !== -1 || t.indexOf('entrance unit') !== -1 || h.indexOf('entrance-unit') !== -1) {
      return 'entrance-units';
    }

    // 5. Exterior Doors
    if (u.indexOf('view=exterior') !== -1 || t.indexOf('exterior') !== -1) {
      if (t.indexOf('round top') !== -1 || h.indexOf('round-top') !== -1 || h.indexOf('arch') !== -1) {
        return 'arch-round-top-exterior-doors';
      }
      if (t.indexOf('double') !== -1 || h.indexOf('double') !== -1 || h.indexOf('dbl-') !== -1) {
        return 'double-exterior-doors';
      }
      if (t.indexOf('dutch') !== -1 || h.indexOf('dutch') !== -1) {
        return 'dutch-exterior-doors';
      }
      if (t.indexOf('french') !== -1 || h.indexOf('french') !== -1) {
        return 'french-exterior-doors';
      }
      if (t.indexOf('rustic') !== -1 || h.indexOf('rustic') !== -1) {
        return 'rustic-exterior-doors';
      }
      if ((t.indexOf('craftsman') !== -1 || h.indexOf('craftsman') !== -1) && (t.indexOf('glass') !== -1 || h.indexOf('glass') !== -1 || u.indexOf('exterior-glass-doors') !== -1)) {
        return 'craftsman-exterior-doors';
      }
      if (t.indexOf('glass') !== -1 || h.indexOf('glass') !== -1) {
        return 'glass-exterior-doors';
      }
      if (t.indexOf('solid wood') !== -1 || h.indexOf('solid-wood') !== -1) {
        return 'solid-wood-exterior-doors';
      }
      return 'solid-wood-exterior-doors';
    }

    // 6. Interior Doors
    if (u.indexOf('view=interior') !== -1 || t.indexOf('interior') !== -1) {
      if (t.indexOf('round top') !== -1 || h.indexOf('round-top') !== -1 || h.indexOf('arch') !== -1) {
        return 'arch-round-top-interior-doors';
      }
      if (t.indexOf('double') !== -1 || h.indexOf('double') !== -1 || h.indexOf('dbl-') !== -1) {
        return 'double-interior-doors';
      }
      if (t.indexOf('dutch') !== -1 || h.indexOf('dutch') !== -1) {
        return 'dutch-interior-doors';
      }
      if (t.indexOf('french') !== -1 || h.indexOf('french') !== -1) {
        return 'french-interior-doors';
      }
      if (t.indexOf('rustic') !== -1 || h.indexOf('rustic') !== -1) {
        return 'rustic-interior-doors';
      }
      if (t.indexOf('louver') !== -1 || h.indexOf('louver') !== -1) {
        return 'louver-interior-doors';
      }
      if ((t.indexOf('craftsman') !== -1 || h.indexOf('craftsman') !== -1) && (t.indexOf('glass') !== -1 || h.indexOf('glass') !== -1 || u.indexOf('interior-glass-doors') !== -1)) {
        return 'craftsman-interior-doors';
      }
      if (t.indexOf('glass') !== -1 || h.indexOf('glass') !== -1) {
        return 'glass-interior-doors';
      }
      if (t.indexOf('solid wood') !== -1 || h.indexOf('solid-wood') !== -1) {
        return 'solid-wood-interior-doors';
      }
      return 'solid-wood-interior-doors';
    }

    // 7. Transoms, Sidelights, Millwork, Hardware
    if (u.indexOf('view=transoms') !== -1 || t.indexOf('transom') !== -1 || h.indexOf('transom') !== -1) {
      return 'exterior-transoms';
    }
    if (u.indexOf('view=sidelights') !== -1 || t.indexOf('sidelight') !== -1 || h.indexOf('sidelight') !== -1) {
      return 'exterior-sidelights';
    }
    if (u.indexOf('view=millwork') !== -1 || t.indexOf('millwork') !== -1) {
      return 'millwork';
    }
    if (u.indexOf('view=hardware') !== -1 || t.indexOf('hardware') !== -1) {
      return 'hardware';
    }
    return 'screen-storm-doors';
  }

  /* MERGE: seo_pdp_url — start (sanitize to /products/ only — do not rewrite to /collections/) */
  function sanitizeProductUrl(url, title, handle) {
    if (!url || typeof url !== 'string') return url;
    var prodIdx = url.indexOf('/products/');
    if (prodIdx === -1) return url;
    var rest = url.substring(prodIdx);
    var qIdx = rest.indexOf('?');
    var pathOnly = qIdx === -1 ? rest : rest.substring(0, qIdx);
    return pathOnly;
  }
  /* MERGE: seo_pdp_url — end */

  function filterProducts(products, query) {
    if (!Array.isArray(products) || !products.length) return products;
    products.forEach(function (p) {
      if (p && p.url) {
        p.url = sanitizeProductUrl(p.url, p.title, p.handle);
      }
    });
    var qNorm = normTitle(query);
    var qSku = normSku(query);
    if (!qNorm && !qSku) return products;
    var exact = products.filter(function (p) {
      return productMatchesExact(p, qNorm, qSku);
    });
    return exact.length ? exact : products;
  }

  function filterSuggestPayload(data, query) {
    if (!data || typeof data !== 'object') return data;
    var resources = data.resources;
    if (!resources || !resources.results) return data;
    var results = resources.results;
    if (Array.isArray(results.products)) {
      results.products = filterProducts(results.products, query);
    }
    return data;
  }

  function isSuggestUrl(url) {
    var s = String(url || '');
    return s.indexOf('/search/suggest') !== -1 || s.indexOf('predictive') !== -1;
  }

  // Intercept fetch (Minimog / Shopify Predictive Search API)
  if (typeof window.fetch === 'function') {
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var req = nativeFetch(input, init);
      if (!isSuggestUrl(url)) return req;
      var query = queryFromUrl(url);
      return req.then(function (response) {
        var ct = (response.headers && response.headers.get('content-type')) || '';
        if (ct.indexOf('application/json') === -1) return response;
        return response
          .clone()
          .json()
          .then(function (data) {
            var filtered = filterSuggestPayload(data, query);
            return new Response(JSON.stringify(filtered), {
              status: response.status,
              statusText: response.statusText,
              headers: { 'Content-Type': 'application/json' }
            });
          })
          .catch(function () {
            return response;
          });
      });
    };
  }

  // Intercept XHR (older Minimog builds)
  if (typeof XMLHttpRequest !== 'undefined') {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__dpSuggestUrl = url;
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr.__dpSuggestUrl && isSuggestUrl(xhr.__dpSuggestUrl)) {
        xhr.addEventListener('readystatechange', function () {
          if (xhr.readyState !== 4 || xhr.status < 200 || xhr.status >= 300) return;
          try {
            var ct = xhr.getResponseHeader('content-type') || '';
            if (ct.indexOf('json') === -1) return;
            var data = JSON.parse(xhr.responseText);
            var filtered = filterSuggestPayload(data, queryFromUrl(xhr.__dpSuggestUrl));
            Object.defineProperty(xhr, 'responseText', {
              configurable: true,
              get: function () {
                return JSON.stringify(filtered);
              }
            });
            if ('response' in xhr) {
              Object.defineProperty(xhr, 'response', {
                configurable: true,
                get: function () {
                  return filtered;
                }
              });
            }
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };
  }

  // DOM fallback: hide non-exact product rows and clean best-sellers / bare products URLs
  function filterPredictiveDom() {
    // Sanitize any generic/parent collection or bare product links rendered in search popup/drawer
    try {
      var links = document.querySelectorAll(
        '.m-search-result__products-list a, .m-predictive-search a, [data-predictive-search] a, .m-search-item, .m-search__results a, predictive-search a, .m-product-card a'
      );
      links.forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href || href.indexOf('/products/') === -1) return;
        var titleEl = a.querySelector('.m-search-item--title, [data-product-title], .m-product-title, h3, h4') || a;
        var title = titleEl ? (titleEl.getAttribute('data-product-title') || titleEl.textContent || '') : '';
        var newHref = sanitizeProductUrl(href, title);
        if (newHref && newHref !== href) {
          a.setAttribute('href', newHref);
        }
      });
    } catch (eLinks) { }

    var roots = document.querySelectorAll(
      '[data-predictive-search], .m-predictive-search, predictive-search, .m-search-hidden, .m-search__results'
    );
    if (!roots.length) {
      roots = document.querySelectorAll('.m-search--results, .predictive-search');
    }
    var input =
      document.querySelector('[name="q"][data-predictive-search], .m-search-hidden input[name="q"], .m-predictive-search input[type="search"], .m-predictive-search input[type="text"], header input[name="q"]') ||
      document.querySelector('input[type="search"][name="q"]');
    var query = input ? input.value : '';
    var qNorm = normTitle(query);
    if (!qNorm || qNorm.split(' ').length < 2) return;

    roots.forEach(function (root) {
      var items = root.querySelectorAll(
        '[data-product-title], .m-product-card, .m-predictive-search--product, a[href*="/products/"]'
      );
      if (!items.length) return;
      var exactNodes = [];
      items.forEach(function (el) {
        var titleEl =
          el.querySelector('[data-product-title], .m-product-card--title, .m-product-title, h3, h4, .h5, .h6') || el;
        var title =
          el.getAttribute('data-product-title') ||
          (titleEl && titleEl.textContent) ||
          '';
        if (normTitle(title) === qNorm) exactNodes.push(el);
      });
      if (!exactNodes.length) {
        items.forEach(function (el) {
          el.style.removeProperty('display');
        });
        return;
      }
      items.forEach(function (el) {
        el.style.display = exactNodes.indexOf(el) !== -1 ? '' : 'none';
      });
    });
  }

  var obsTimer = null;
  function scheduleDomFilter() {
    clearTimeout(obsTimer);
    obsTimer = setTimeout(filterPredictiveDom, 80);
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name="q"], input[type="search"]')) scheduleDomFilter();
  });

  if (typeof MutationObserver !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      var obs = new MutationObserver(scheduleDomFilter);
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
